import { Directive, Input, HostListener, ElementRef, OnInit } from '@angular/core';
import { NODE_MAP } from './node-map';

@Directive({ selector: '[treeAllowDrop]',
  standalone: false })
export class TreeAllowDropDirective implements OnInit {
  @Input('treeAllowDrop') allowDropFn: any;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit() {
    // no-op
  }

  @HostListener('dragover', ['$event']) onDragOver(ev: DragEvent) {
    // allow drop when the node's allowDrop returns true
    try {
      if (this.allowDropFn && typeof this.allowDropFn === 'function') {
        const ok = this.allowDropFn();
        if (ok) ev.preventDefault();
      } else {
        ev.preventDefault();
      }
    } catch (e) {
      // fallback
      ev.preventDefault();
    }
  }

  @HostListener('drop', ['$event']) onDrop(ev: DragEvent) {
    try {
      const node = (ev as any).__ecpl_node || null;
      // try to find node mapped to target element
      const targetNode = NODE_MAP.get(this.el.nativeElement) || null;
      // call target node's onDrop if present
      if (targetNode && typeof targetNode.onDrop === 'function') {
        targetNode.onDrop({ from: node, to: targetNode, originalEvent: ev });
      }
    } catch (e) {}
  }
}
